// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles__wrapper___1ahgy","message":"styles__message___J796m","toggle":"styles__toggle___2KyKa"};